import {
  MENU_CODE_ADD_NEW_PRODUCT,
  MENU_CODE_BENCHMARK,
  MENU_CODE_CHANGE_LOG,
  MENU_CODE_GATE_REVIEW,
  MENU_CODE_GLOBALPEDIA,
  MENU_CODE_GROSS_REVENUE_TRENDS,
  MENU_CODE_IN_DEVELOPMENT,
  MENU_CODE_LIVE_TITLE,
  MENU_CODE_METRICS,
  MENU_CODE_MY_WORKSPACE,
  MENU_CODE_NEWSLETTER,
  MENU_CODE_OVERVIEW,
  MENU_CODE_PERFORMANCE_OVERVIEW,
  MENU_CODE_PIPELINE,
  MENU_CODE_PROJECT_LIST,
  MENU_CODE_REPORT,
  MENU_CODE_REPORT_PUSH_MANAGEMENT,
  MENU_CODE_STUDIO_DASHBOARD,
  MENU_CODE_STUDIO_MONTHLY_REPORT,
  MENU_CODE_STUDIO_OVERALL,
  MENU_CODE_STUDIO_STUDIO_BUSINESS_METRICS,
  MENU_CODE_FAVORITE_PROJECT,
  MENU_CODE_USER_GUIDE,
  MENU_CODE_VERSION_HISTORY,
} from '@gp/constants/const';
import type { MenuDefaultType } from '@gp/types/global';

export const SIDE_MENU_CODE_MAP: Record<string, MenuDefaultType> = {
  // Studio Monthly Report
  [MENU_CODE_STUDIO_MONTHLY_REPORT]: {
    title: 'Monthly Report',
    icon: 'nav-report',
    defaultOpened: true,
  },
  [MENU_CODE_PERFORMANCE_OVERVIEW]: {
    title: 'Performance Overview',
    to: '/MonthlyReport/PerformanceOverview',
  },
  [MENU_CODE_GROSS_REVENUE_TRENDS]: {
    title: 'Gross Revenue Trends',
    to: '/MonthlyReport/GrossRevenueTrends',
  },
  [MENU_CODE_LIVE_TITLE]: {
    title: 'Live Title',
    to: '/MonthlyReport/LiveTitle',
  },
  [MENU_CODE_IN_DEVELOPMENT]: {
    title: 'In-Development Title',
    to: '/MonthlyReport/InDevTitle',
  },
  // Globalpedia
  [MENU_CODE_GLOBALPEDIA]: {
    title: 'Globalpedia',
    icon: 'menu-ua',
    defaultOpened: true,
  },
  [MENU_CODE_BENCHMARK]: {
    title: 'Benchmark',
    to: '/Globalpedia/Benchmark',
  },
  // Pipeline
  [MENU_CODE_PIPELINE]: {
    title: 'Pipeline',
    icon: 'material',
    defaultOpened: true,
    // showNew: true,
    newMarkType: 0,
  },
  [MENU_CODE_OVERVIEW]: {
    title: 'Overview',
    to: '/Pipeline/Overview',
  },
  [MENU_CODE_PROJECT_LIST]: {
    title: 'Project List',
    to: '/Pipeline/ProjectList',
  },
  // Studio Dashboard
  [MENU_CODE_STUDIO_DASHBOARD]: {
    title: 'Studio',
    icon: 'columnar',
    defaultOpened: true,
  },
  /* [MENU_CODE_STUDIO_MONTHLY_REPORT]: {
    title: 'Studio Monthly Report',
    to: '/Studio/StudioMonthlyReport',
  }, */
  [MENU_CODE_STUDIO_OVERALL]: {
    title: 'Portfolio Overview',
    to: '/Studio/PortfolioOverview',
  },
  [MENU_CODE_STUDIO_STUDIO_BUSINESS_METRICS]: {
    title: 'Metrics Dashboard',
    to: '/Studio/MetricsDashboard',
  },
  // Metrics指标说明页
  [MENU_CODE_METRICS]: {
    title: 'Metrics',
    icon: 'icon-metrics',
    to: '/Metrics',
    // showNew: true,
    newMarkType: 0,
  },
  // Work Space
  [MENU_CODE_MY_WORKSPACE]: {
    title: 'Work Space',
    icon: 'nav-workspace',
    defaultOpened: true,
  },
  [MENU_CODE_ADD_NEW_PRODUCT]: {
    icon: 'ai-task',
    title: 'Add New Project',
    to: '/Workspace/AddProduct',
  },
  [MENU_CODE_GATE_REVIEW]: {
    title: 'Product Review',
    to: '/Workspace/ProductReview',
  },
  // Newsletter
  [MENU_CODE_NEWSLETTER]: {
    title: 'Newsletter',
    icon: 'menu-email-report',
    defaultOpened: true,
  },
  [MENU_CODE_REPORT]: {
    title: 'Report',
    to: '/Newsletter/Report',
  },
  [MENU_CODE_REPORT_PUSH_MANAGEMENT]: {
    title: 'Push Management',
    to: '/Newsletter/PushManagement',
  },
  [MENU_CODE_CHANGE_LOG]: {
    title: 'Change Log',
    icon: '',
    to: '/Pipeline/ChangeLog',
    // showNew: true,
    newMarkType: 0,
  },
  [MENU_CODE_FAVORITE_PROJECT]: {
    icon: 'star-m',
    title: 'Favorite Project',
    showNew: true,
    to: '/',
  },
  [MENU_CODE_USER_GUIDE]: {
    icon: 'user-guide',
    title: 'User Guide',
    type: 'onclickBtn',
    showNew: true,
    to: '/',
  },
  [MENU_CODE_VERSION_HISTORY]: {
    icon: 'book-m',
    title: 'Version History',
    type: 'onclickBtn',
    showNew: true,
    to: '/VersionHistory',
  },
};

export const ROUTE_EVENT_NAME = 'matched_routes';
